import {
  GetFirstPublishedKurssloeyfeElementId,
  GetFirstPublishedKurssloeyfeElementId_elements,
} from "__generated__/types";
import { urls } from "common/urls";
import { isElementPublished } from "domain/common/utils";
import { ElementNavListItem } from "domain/pages/ElementPage";
import gql from "graphql-tag";

gql`
  fragment GetFirstPublishedKurssloeyfeElementId on Kurssloeyfe {
    elements {
      id
      content {
        id
        status
      }
    }
  }
`;

export function getFirstPublishedKurssloeyfeElementId(
  value: Omit<GetFirstPublishedKurssloeyfeElementId, "__typename">,
): string | undefined {
  return value.elements.filter((it) => isElementPublished(it))[0]?.id;
}

export function getFirstPublishedKurssloeyfeElement(
  value: Omit<GetFirstPublishedKurssloeyfeElementId, "__typename">,
): GetFirstPublishedKurssloeyfeElementId_elements | undefined {
  return value.elements.filter((it) => isElementPublished(it))[0];
}

const isArticleOrVideo = (typename: string) =>
  typename === "Article" || typename === "Video;";

export function buildKurssloeyfeElementUrl(item: ElementNavListItem) {
  if (!item.id) {
    throw new Error("Unexpected error: Missing item.id");
  }

  if (!item.containerId) {
    throw new Error("Unexpected error: Missing item.containerId");
  }

  return isArticleOrVideo(item.__typename)
    ? urls.kurssloeyfeArticle(item.contentId, item.containerId)
    : urls.kurssloeyfeQuestion(item.contentId, item.containerId);
}

// We use the instance ID of the articles and questions, not the original content ID
export function buildSelfAssessmentElementUrl(item: ElementNavListItem) {
  if (!item.id) {
    throw new Error("Unexpected error: Missing item.id");
  }

  if (!item.containerId) {
    throw new Error("Unexpected error: Missing item.containerId");
  }

  return isArticleOrVideo(item.__typename)
    ? urls.selfAssessmentArticle(item.id, item.containerId)
    : urls.selfAssessmentQuestion(item.id, item.containerId);
}
